<template>
  <v-container fluid grid-list-md id="page-body" :class="{'px-0': $vuetify.breakpoint.smAndDown}">

    <v-layout row>
      <v-flex xs12 sm4
          v-for="(item, idx) in dataList"
          :key="idx">
        <datacard :lists="item" v-if="is_data_fetched"></datacard>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import dataApi from '../services/ApiService'

export default {
  name: 'Development',
  data: () => ({
      loading: false,
      is_data_fetched: false,
      dataList: []
  }),
  methods: {
    getDataFile() {
      dataApi.fetchDataFile ('development-data.json')
      .then(response => {
        if (Object.keys(response).length) {
          // eslint-disable-next-line no-console
          console.log(response)
          this.dataList = response.dataList
          this.is_data_fetched = true
        }
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log(error)
      })

    }
  },
  mounted () {
    this.getDataFile()
  }
  
}
</script>

<style lang="scss" scoped>
</style>
